import * as R from 'ramda'

export const getUpdated = (
  newObj: Record<string, unknown>,
  baseObj: Record<string, unknown>,
) =>
  R.keys(newObj).reduce(
    (acc, key) =>
      R.unless(
        () => R.eqProps(key, newObj, baseObj),
        R.assoc(key, newObj[key]),
        acc,
      ),
    {},
  )

export const nothing = () => {}

export function maxOfArray<T>(
  compareBy: (value: T) => number | string | boolean | Date,
  array: T[],
) {
  return array.reduce(
    (prev, current) => R.maxBy(compareBy, prev, current),
    array[0],
  )
}

/**
 * TODO: Must be reviewed as new uuid replacement in database
 * @deprecated
 */
export const isMongoObjectId = (id: string) => id.match(/^[0-9a-fA-F]{24}$/)

export function getBoundaryData<T, K>(arr: T[], fn: (data: T) => K) {
  return { start: fn(arr[0]), end: fn(arr[arr.length - 1]) }
}

export function normalizeListByKey<T>(key: keyof T, list: T[]) {
  const grouped = R.groupBy(
    item => (R.prop(key, item) as unknown) as string,
    list,
  )
  return R.map(R.last, grouped) as Record<string, T>
}

// @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
export const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

export function isNumber(num: unknown) {
  return typeof num === 'number' && !Number.isNaN(num)
}
